// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 26,
  argument: "Of good and bad women.",
  verses: [
    { n: 1, text: "Happy is the husband of a good wife: for the number of his years is double." },
    { n: 2, text: "A virtuous woman rejoiceth her husband, and shall fulfil the years of his life in peace." },
    { n: 3, text: "A good wife is a good portion: she shall be given in the portion of them that fear God, to a man for his good deeds:" },
    { n: 4, text: "Rich or poor, if his heart is good, his countenance shall be cheerful at all times." },
    { n: 5, text: "Of three things my heart hath been afraid, and at the fourth my face hath trembled:" },
    { n: 6, text: "The accusation of a city, and the gathering together of the people:" },
    { n: 7, text: "And a false calumny, all are more grievous than death." },
    { n: 8, text: "A jealous woman is the grief and mourning of the heart." },
    { n: 9, text: "With a jealous woman is a scourge of the tongue which communicateth with all." },
    { n: 10, text: "As a yoke of oxen that is moved to and fro, so also is a wicked woman: he that hath hold of her, is as he that taketh hold of a scorpion." },
    { n: 11, text: "A drunken woman is a great wrath: and her reproach and shame shall not be hid." },
    { n: 12, text: "The fornication of a woman shall be known by the haughtiness of her eyes, and by her eye-lids." },
    { n: 13, text: "On a daughter that turneth not away herself, set a strict watch: lest finding an opportunity she abuse herself." },
    { n: 14, text: "Take heed of the impudence of her eyes, and wonder not if she slight thee." },
    { n: 15, text: "She will open her mouth as a thirsty traveller to the fountain, and will drink of every water near her, and will sit down by every hedge, and open her quiver against every arrow, until she fail." },
    { n: 16, text: "The grace of a diligent woman shall delight her husband, and shall fatten his bones." },
    { n: 17, text: "Her discipline is the gift of God." },
    { n: 18, text: "Such is a wise and silent woman, and there is nothing so much worth as a well instructed soul." },
    { n: 19, text: "A holy and shamefaced woman is grace upon grace." },
    { n: 20, text: "And no price is worthy of a continent soul." },
    { n: 21, text: "As the sun, when it riseth to the world in the high places of God, so is the beauty of a good wife for the ornament of her house." },
    { n: 22, text: "As the lamp shining upon the holy candlestick, so is the beauty of the face in a ripe age." },
    { n: 23, text: "As golden pillars upon bases of silver, so are the firm feet upon the soles of a steady woman." },
    { n: 24, text: "As everlasting foundations upon a solid rock, so the commandments of God In the heart of a holy woman." },
    { n: 25, text: "At two things my heart is grieved, and the third bringeth anger upon me:" },
    { n: 26, text: "A man of war fainting through poverty: and a man of sense despised:" },
    { n: 27, text: "And he that passeth over from justice to sin, God hath prepared such an one for the sword." },
    { n: 28, text: "Two sorts of callings have appeared to me hard and dangerous: a merchant is hardly free from negligence: and a huckster shall not be justified from the sins of the lips." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Double. Uneasiness deprives a person of much comfort.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "To a, &c., is not in Greek.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Fourth. A jealous wife,", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "City. When all are charged with a crime, or when all rise up against a man.", attribution: "Calmet" }
    ] },
    { verse: 9, notes: [
      { text: "With. Greek, \"and the scourge of the tongue, which,\" &c. (Haydock) — Back-biting occasions the four evils aforesaid.", attribution: "Grotius" }
    ] },
    { verse: 10, notes: [
      { text: "Woman. When oxen move, the yoke moves also: Thus heresy will suffer none to rest. (Worthington) — The yoke ought to fit the neck, and not be fastened to the horns.", attribution: "Colum. ii. 2." }
    ] },
    { verse: 11, notes: [
      { text: "Hid. She will be given to debauchery. (St. Chrysostom) (Calmet) — Romulus ordered wives to be slain, like adulteresses, who had drunk wine at home.", attribution: "V. Max. vi. 3." }
    ] },
    { verse: 12, notes: [
      { text: "Eye-lids. Shewing her impudence, 2 Peter ii. 14., and Isaias iii. 16.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "Herself. From gazing at men. (Calmet) — Love manifests itself by the eyes.", attribution: "Propert." }
    ] },
    { verse: 15, notes: [
      { text: "Hedge. Or \"stake,\" palum, (Haydock) on which tents were fixed, Genesis xxxviii. 14. (Calmet) — Fail. Incontinence will at last ruin her health.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Bones. The Catholic faith is the ground of all virtues.", attribution: "Worthington" }
    ] },
    { verse: 18, notes: [
      { text: "Worth. Literally, \"exchange;\" (Greek; Haydock) such a wife is above all price.", attribution: "Menochius" }
    ] },
    { verse: 20, notes: [
      { text: "Continent. Adhering to virtue.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Holy. Made of gold, and placed in the sanctuary.", attribution: "Menochius" }
    ] },
    { verse: 23, notes: [
      { text: "Soles. Greek, \"heels.\" Complutensian, \"solid pavement.\" A long addition follows in this edition, which is inserted by Grabe, (Haydock; but is not in the best copies. Calmet) instead of the following verse.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Poverty. The Romans provided for veteran soldiers, as Louis XIV did with great magnificence. (Calmet) — Greenwich hospital is for the same purpose. (Haydock) — Despised. Solomon makes the same complaint, Ecclesiastes ix. 15.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "To sin. He is less excusable, as he knows what he abandons, Jeremias ii. 12.", attribution: "Calmet" }
    ] },
    { verse: 28, notes: [
      { text: "Two. Greek, \"scarcely is a merchant exempt from negligence, and the seller of wine, and eatables, (Grotius) or retailer (Voss. kapelos) shall not be justified from sin.\" (Haydock) — Negligence. That is, from the neglect of the service of God: because the eager pursuit of the mammon of this world, is apt to make men of that calling forget the great duties of loving God above all things, and their neighbours as themselves. — A huckster. Or a retailer of wine. Men of that profession are both greatly exposed to danger of sin themselves, and are too often accessary to the sins of others. (Challoner) — Lips. Innkeepers talk much to please, and thus fall into danger, Proverbs x. 19. (Worthington) — They are also exposed to lying, (Menochius) and to adulterate their merchandise.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
